import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig';

let currentMenuName = 'ai-text-to-full-video';
if (location.pathname.includes('text-to-full-video')) {
    currentMenuName = 'ai-text-to-full-video';
} else if (location.pathname.includes('blog-url-to-video')) {
    currentMenuName = 'ai-blog-url-to-video';
} else if (location.pathname.includes('product-url-to-ads')) {
    currentMenuName = 'ai-product-url-to-video';
} else if (location.pathname.includes('ppt-to-video')) {
    currentMenuName = 'ai-ppt-to-video';
}

const environment = import.meta.env.MODE;

export default {
    textToImageStylePreviewPath:
        environment === LOCAL ? `/public/img/textToImage/styles/` : `/app/ai-tools/img/textToImage/styles/`,
    textToImageStylesJsonPath:
        environment === LOCAL
            ? `/public/preloadData/textToVideo/imageStyles.json?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/preloadData/textToVideo/imageStyles.json?v=${FJVersionConfig.staticPathVersion}`,
    historyListType: 6,
    subtitleStylePath: environment === LOCAL ? 'public/img/subtitleStyle' : 'app/ai-tools/img/subtitleStyle',
    textToImageResultImageKey: 'ai/export/text2img/',
    resourceImagePath: environment === LOCAL ? `/public/img/textToVideo/` : `/app/ai-tools/img/textToVideo/`,
    pptUploadFileKey: 'ai/input/doc2text/',
    pptResultKey: 'ai/export/doc2text/',
    freeLimitType: 'text-to-video',
    currentMenuName,
};
